// Contract type identifiers (mirror of the HRMS contract type ids)
export const CONTRACT_TYPES = {
  NONE: 1,
  OFFICIAL: 2,
  GIG: 3,
  PE: 4,
  CASH: 5
};

// Single source of truth for contract type labels and badge colors.
// `color` is the solid badge background, `textColor` the text drawn on it.
const CONTRACT_TYPE_CONFIG = {
  [CONTRACT_TYPES.OFFICIAL]: { label: 'Official', color: '#ffd3b6', textColor: '#000' },
  [CONTRACT_TYPES.GIG]: { label: 'GIG', color: '#4ecdc4', textColor: '#fff' },
  [CONTRACT_TYPES.PE]: { label: 'PE', color: '#e3a2f1', textColor: '#000' },
  [CONTRACT_TYPES.CASH]: { label: 'Cash', color: '#a5acff', textColor: '#000' }
};

const UNKNOWN_CONFIG = { label: 'Unknown', color: '#ccc', textColor: '#000' };

// Returns the config for a contract type, augmented with a translucent `bgLight`
// variant (used for cell backgrounds). Falls back to a neutral "Unknown" config.
export const getContractTypeConfig = (contractType) => {
  const cfg = CONTRACT_TYPE_CONFIG[contractType] || UNKNOWN_CONFIG;
  return { ...cfg, bgLight: `${cfg.color}40` };
};

// Display order used by filter dropdowns / menus.
const CONTRACT_TYPE_ORDER = [
  CONTRACT_TYPES.GIG,
  CONTRACT_TYPES.PE,
  CONTRACT_TYPES.CASH,
  CONTRACT_TYPES.OFFICIAL
];

// Options for contract-type filter selects: [{ value, label }]
export const contractTypeOptions = CONTRACT_TYPE_ORDER.map((value) => ({
  value,
  label: CONTRACT_TYPE_CONFIG[value].label
}));

export default CONTRACT_TYPE_CONFIG;
